import { useState } from 'react';
import { MdClose } from 'react-icons/md';

/**
 * Reusable rejection-reason modal: a dropdown of default reasons + an "Other"
 * free-text option. Used for rejecting contributors, submissions, and withdrawals.
 *
 * Props:
 *  - title, reasons: string[], confirmLabel, confirmClass
 *  - busy: boolean, onCancel(), onConfirm(reasonText)
 */
export default function ReasonModal({
  title = 'Reject',
  reasons = [],
  confirmLabel = 'Reject',
  confirmClass = 'btn-danger',
  busy = false,
  onCancel,
  onConfirm,
}) {
  const [selected, setSelected] = useState(reasons[0] || 'Other');
  const [custom, setCustom] = useState('');

  const isOther = selected === 'Other';
  const finalReason = isOther ? custom.trim() : selected;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal modal-sm" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close" onClick={onCancel}><MdClose /></button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>Reason</label>
            <select value={selected} onChange={(e) => setSelected(e.target.value)}>
              {reasons.map((r) => (
                <option key={r} value={r}>{r}</option>
              ))}
            </select>
          </div>
          {isOther && (
            <div className="form-group">
              <label>Specify reason</label>
              <textarea
                rows={3}
                value={custom}
                placeholder="Type the reason shown to the contributor…"
                onChange={(e) => setCustom(e.target.value)}
              />
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onCancel} disabled={busy}>Cancel</button>
          <button
            className={`btn ${confirmClass}`}
            disabled={busy || !finalReason}
            onClick={() => onConfirm(finalReason)}
          >
            {busy ? 'Please wait…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
